import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DynamicFormComponent,
  DynamicFormComponentService,
  DynamicFormControlEvent,
  DynamicFormLayout,
  DynamicFormModel,
  DynamicTemplateDirective,
} from '@ng-dynamic-forms/core';
import { TranslatePipe } from '@spartacus/core';
import { DynamicMaterialFormControlContainerComponent } from './dynamic-material-form-control-container.component';

@Component({
  selector: 'dynamic-material-form',
  templateUrl: './dynamic-material-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicMaterialFormControlContainerComponent, NgClass, TranslatePipe],
})
export class DynamicMaterialFormComponent extends DynamicFormComponent {
  @Input() group: FormGroup;
  @Input() model: DynamicFormModel;
  @Input() layout: DynamicFormLayout;
  @Input() getLanguage: any;

  @Output() blur: EventEmitter<DynamicFormControlEvent> = new EventEmitter<DynamicFormControlEvent>();
  @Output() change: EventEmitter<DynamicFormControlEvent> = new EventEmitter<DynamicFormControlEvent>();
  @Output() focus: EventEmitter<DynamicFormControlEvent> = new EventEmitter<DynamicFormControlEvent>();

  @Output() matEvent: EventEmitter<DynamicFormControlEvent> = new EventEmitter<DynamicFormControlEvent>();

  @ContentChildren(DynamicTemplateDirective) templates: QueryList<DynamicTemplateDirective>;

  @ViewChildren(DynamicMaterialFormControlContainerComponent)
  components: QueryList<DynamicMaterialFormControlContainerComponent>;

  constructor(protected changeDetectorRef: ChangeDetectorRef, protected componentService: DynamicFormComponentService) {
    super(changeDetectorRef, componentService);
  }

  get formControlTerms(): any {
    let terms = [];

    if (this.group.get('orderType')) {
      const obj = {
        key:
          this.group.get('orderType').value === 'SO'
            ? 'checkout.group.orderType.terms.SO'
            : 'checkout.group.orderType.terms.PO',
        class: 'orderTypeTerms',
      };
      terms.push(obj);
    }

    return terms;
  }
}
